import {
  GET_SALESFORCE_DESCRIBE_REQUEST,
  GET_SALESFORCE_DESCRIBE_SUCCESS,
  GET_SALESFORCE_DESCRIBE_FAILURE,
  GET_SALESFORCE_PREVIEW_REQUEST,
  GET_SALESFORCE_PREVIEW_SUCCESS,
  GET_SALESFORCE_PREVIEW_FAILURE,
  GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE,
  GET_SALESFORCE_USERINFO_REQUEST,
  GET_SALESFORCE_USERINFO_SUCCESS,
  GET_SALESFORCE_USERINFO_FAILURE,
  POST_SALESFORCE_REVOKE_REQUEST,
  POST_SALESFORCE_REVOKE_SUCCESS,
  POST_SALESFORCE_REVOKE_FAILURE,
  GET_SALESFORCE_SYNC_LAST_UPDATE_REQUEST,
  GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS,
  GET_SALESFORCE_SYNC_LAST_UPDATE_FAILURE,
  POST_SALESFORCE_SYNC_REQUEST,
  POST_SALESFORCE_SYNC_SUCCESS,
  POST_SALESFORCE_SYNC_FAILURE,
  GET_SALESFORCE_LISTVIEWS_REQUEST,
  GET_SALESFORCE_LISTVIEWS_SUCCESS,
  GET_SALESFORCE_LISTVIEWS_FAILURE,
  POST_SALESFORCE_CONFIG_REQUEST,
  POST_SALESFORCE_CONFIG_SUCCESS,
  POST_SALESFORCE_CONFIG_FAILURE,
  GET_SALESFORCE_CONFIG_REQUEST,
  GET_SALESFORCE_CONFIG_SUCCESS,
  GET_SALESFORCE_CONFIG_FAILURE,
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST,
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS,
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE,
  GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE,
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST,
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS,
  GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS,
  POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE,
  GET_SALESFORCE_IMPORT_HISTORIES_REQUEST,
  GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS,
  GET_SALESFORCE_IMPORT_HISTORIES_FAILURE,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS,
  GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE,
  GET_SALESFORCE_EXPORT_HISTORIES_REQUEST,
  GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS,
  GET_SALESFORCE_EXPORT_HISTORIES_FAILURE,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS,
  GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE,
} from "../../constants/ActionTypes";
import { SalesforceApi } from "../api/SalesforceApi";
import { SALESFORCE_PREVIEW_LIMIT } from "../../constants/Constants";
import {
  SalesforceExeExportObjectType,
  SalesforceTimelineStatusExportObjectType,
  SalesforceObjectType,
} from "../../constants/ComponentTypes";
import { jobCompletedRequest } from "./Broadcasting";

import { getUser } from "./AccountSetting";

/*** GET /salesforce/describe ***/
const getSalesforceDescribeRequest = (sobject_name) => ({
  type: GET_SALESFORCE_DESCRIBE_REQUEST,
  payload: {
    sobject_name: sobject_name,
  },
});

const getSalesforceDescribeSuccess = (sobject_name, fields) => ({
  type: GET_SALESFORCE_DESCRIBE_SUCCESS,
  payload: {
    sobject_name: sobject_name,
    fields: fields,
  },
});

const getSalesforceDescribeFailure = (error) => ({
  type: GET_SALESFORCE_DESCRIBE_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceDescribe(sobject_name) {
  return async (dispatch) => {
    dispatch(getSalesforceDescribeRequest(sobject_name));

    SalesforceApi.getSalesforceDescribe(sobject_name, dispatch)
      .then((response) => {
        // Feature/#4146 【Salesforce連携 > 自社リスト】取引責任者からインポートの場合、紐づく取引先情報もインポートするように修正
        // sobject_nameがContactの場合、/vXX.X/sobjects/contact/describe/に「取引先名」の項目を追加する
        let res = response.data.data;

        if (
          typeof res === "object" &&
          sobject_name === SalesforceObjectType.CONTACT.value
        ) {
          let fields = res.fields;
          fields["accountName"] = {
            isRequired: true,
            label: "取引先名",
            name: "Account.Name",
            soapType: "xsd:string",
            type: "string",
            updateable: true,
          };
          res.fields = fields;
        }

        dispatch(
          getSalesforceDescribeSuccess(sobject_name, response.data.data)
        );
      })
      .catch((error) => {
        dispatch(getSalesforceDescribeFailure(error.response));
      });
  };
}

/*** GET /salesforce/preview ***/
const getSalesforcePreviewRequest = () => ({
  type: GET_SALESFORCE_PREVIEW_REQUEST,
});

const getSalesforcePreviewSuccess = (data) => ({
  type: GET_SALESFORCE_PREVIEW_SUCCESS,
  payload: {
    data: data,
  },
});

const getSalesforcePreviewFailure = (error) => ({
  type: GET_SALESFORCE_PREVIEW_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforcePreview(sobject_name, data) {
  return async (dispatch) => {
    dispatch(getSalesforcePreviewRequest());

    SalesforceApi.getSalesforcePreview(sobject_name, data, dispatch)
      .then((response) => {
        dispatch(getSalesforcePreviewSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSalesforcePreviewFailure(error.response));
      });
  };
}

/*** GET /salesforce/config ***/
const getSalesforceConfigRequest = () => ({
  type: GET_SALESFORCE_CONFIG_REQUEST,
});

const getSalesforceConfigSuccess = (
  salesforce_integration_setting_id,
  address_import_mappings_flag,
  exe_export_mappings_flag,
  timeline_status_export_mappings_flag
) => ({
  type: GET_SALESFORCE_CONFIG_SUCCESS,
  payload: {
    salesforce_integration_setting_id: salesforce_integration_setting_id,
    address_import_mappings_flag: address_import_mappings_flag,
    exe_export_mappings_flag: exe_export_mappings_flag,
    timeline_status_export_mappings_flag: timeline_status_export_mappings_flag,
  },
});

const getSalesforceConfigFailure = (error) => ({
  type: GET_SALESFORCE_CONFIG_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceConfig() {
  return async (dispatch) => {
    dispatch(getSalesforceConfigRequest());

    SalesforceApi.getSalesforceConfig(null, dispatch)
      .then((response) => {
        if (response.data.data.length > 0) {
          let setting = response.data.data[0];
          dispatch(
            getSalesforceConfigSuccess(
              setting.id,
              setting.address_import_mappings_flag,
              setting.exe_export_mappings_flag,
              setting.timeline_status_export_mappings_flag
            )
          );
        } else {
          dispatch(
            getSalesforceConfigFailure("連携設定が見つかりませんでした。")
          );
        }
      })
      .catch((error) => {
        dispatch(getSalesforceConfigFailure(error.response));
      });
  };
}

/*** GET /salesforce_import_mappings ***/
const getSalesforceImportMappingsRequest = () => ({
  type: GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST,
});

const getSalesforceImportMappingsSuccess = (
  sobject_name,
  listview_id,
  mapping,
  fields,
  preview,
  listviews
) => ({
  type: GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS,
  payload: {
    sobject_name: sobject_name,
    listview_id: listview_id,
    mapping: mapping,
    fields: fields,
    preview: preview,
    listviews: listviews,
  },
});

const getSalesforceImportMappingsFailure = (error) => ({
  type: GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceImportMappings() {
  return async (dispatch) => {
    dispatch(getSalesforceImportMappingsRequest());

    SalesforceApi.getSalesforceImportMappings(dispatch)
      .then((response) => {
        if (response.data.data.length > 0) {
          let sobject_name = response.data.data[0].sobject_name;
          let listview_id = response.data.data[0].listview_id;
          let mapping = response.data.data[0].mapping;

          Promise.all([
            SalesforceApi.getSalesforceDescribe(sobject_name, dispatch),
            SalesforceApi.getSalesforcePreview(
              sobject_name,
              {
                ...mapping,
                listview_id: listview_id,
                limit: SALESFORCE_PREVIEW_LIMIT,
              },
              dispatch
            ),
            SalesforceApi.getSalesforceListviews(sobject_name, dispatch),
          ])
            .then((values) => {
              const promiseFirstIndex = 0;
              const promiseSecondIndex = 1;
              const promiseThirdIndex = 2;

              let describeRes = values[promiseFirstIndex],
                previewRes = values[promiseSecondIndex],
                listviewsRes = values[promiseThirdIndex];

              // Feature/#4146 【Salesforce連携 > 自社リスト】取引責任者からインポートの場合、紐づく取引先情報もインポートするように修正
              // sobject_nameがContactの場合、/vXX.X/sobjects/contact/describe/に「取引先名」の項目を追加する
              let res = describeRes.data.data;

              if (
                typeof res === "object" &&
                sobject_name === SalesforceObjectType.CONTACT.value
              ) {
                let fields = res.fields;
                fields["accountName"] = {
                  isRequired: true,
                  label: "取引先名",
                  name: "Account.Name",
                  soapType: "xsd:string",
                  type: "string",
                  updateable: true,
                };
                res.fields = fields;
              }

              dispatch(
                getSalesforceImportMappingsSuccess(
                  sobject_name,
                  listview_id,
                  mapping,
                  describeRes.data.data,
                  previewRes.data,
                  listviewsRes.data.listviews
                )
              );
            })
            .catch((error) => {
              dispatch(getSalesforceImportMappingsFailure(error.response));
            });
        } else {
          dispatch(
            getSalesforceImportMappingsFailure({
              message: "マッピングが存在しません。",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(getSalesforceImportMappingsFailure(error.response));
      });
  };
}

/*** GET /salesforce/userinfo ***/
const getSalesforceUserinfoRequest = () => ({
  type: GET_SALESFORCE_USERINFO_REQUEST,
});

const getSalesforceUserinfoSuccess = (data) => ({
  type: GET_SALESFORCE_USERINFO_SUCCESS,
  payload: {
    data: data,
  },
});

const getSalesforceUserinfoFailure = (error) => ({
  type: GET_SALESFORCE_USERINFO_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceUserinfo() {
  return async (dispatch) => {
    dispatch(getSalesforceUserinfoRequest());

    SalesforceApi.getSalesforceUserinfo(dispatch)
      .then((response) => {
        dispatch(getSalesforceUserinfoSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSalesforceUserinfoFailure(error.response));
      });
  };
}

/*** POST /salesforce/revoke ***/
const postSalesforceRevokeRequest = () => ({
  type: POST_SALESFORCE_REVOKE_REQUEST,
});

const postSalesforceRevokeSuccess = () => ({
  type: POST_SALESFORCE_REVOKE_SUCCESS,
  payload: {},
});

const postSalesforceRevokeFailure = (error) => ({
  type: POST_SALESFORCE_REVOKE_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceRevoke() {
  return async (dispatch) => {
    dispatch(postSalesforceRevokeRequest());

    SalesforceApi.postSalesforceRevoke(null, dispatch)
      .then(() => {
        getUser();
        dispatch(postSalesforceRevokeSuccess());
      })
      .catch((error) => {
        dispatch(postSalesforceRevokeFailure(error.response));
      });
  };
}

/*** GET /oauth2/salesforce/sync/last_update ***/
const getSalesforceSyncLastUpdateRequest = () => ({
  type: GET_SALESFORCE_SYNC_LAST_UPDATE_REQUEST,
});

const getSalesforceSyncLastUpdateSuccess = (data) => ({
  type: GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS,
  payload: {
    data: data,
  },
});

const getSalesforceSyncLastUpdateFailure = (error) => ({
  type: GET_SALESFORCE_SYNC_LAST_UPDATE_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceSyncLastUpdate(data = null) {
  return async (dispatch) => {
    dispatch(getSalesforceSyncLastUpdateRequest());

    SalesforceApi.getSalesforceSyncLastUpdate(data, dispatch)
      .then((response) => {
        dispatch(
          getSalesforceSyncLastUpdateSuccess(response.data.data)
        );
      })
      .catch((error) => {
        dispatch(getSalesforceSyncLastUpdateFailure(error.response));
      });
  };
}

/*** POST /salesforce/sync ***/
const postSalesforceSyncRequest = () => ({
  type: POST_SALESFORCE_SYNC_REQUEST,
});

const postSalesforceSyncSuccess = (data) => ({
  type: POST_SALESFORCE_SYNC_SUCCESS,
  payload: {
    message: data.message,
    data: data.data,
  },
});

const postSalesforceSyncFailure = (error) => ({
  type: POST_SALESFORCE_SYNC_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceSync() {
  return async (dispatch) => {
    dispatch(jobCompletedRequest());
    dispatch(postSalesforceSyncRequest());

    SalesforceApi.postSalesforceSync(null, dispatch)
      .then((response) => {
        dispatch(getSalesforceSyncLastUpdate());
        dispatch(postSalesforceSyncSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postSalesforceSyncFailure(error.response));
      });
  };
}

/*** GET /salesforce/listviews ***/
const getSalesforceListviewsRequest = (sobject_name) => ({
  type: GET_SALESFORCE_LISTVIEWS_REQUEST,
  payload: {
    sobject_name: sobject_name,
  },
});

const getSalesforceListviewsSuccess = (sobject_name, listviews) => ({
  type: GET_SALESFORCE_LISTVIEWS_SUCCESS,
  payload: {
    sobject_name: sobject_name,
    listviews: listviews,
  },
});

const getSalesforceListviewsFailure = (error) => ({
  type: GET_SALESFORCE_LISTVIEWS_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceListviews(sobject_name) {
  return async (dispatch) => {
    dispatch(getSalesforceListviewsRequest(sobject_name));

    SalesforceApi.getSalesforceListviews(sobject_name, dispatch)
      .then((response) => {
        dispatch(
          getSalesforceListviewsSuccess(sobject_name, response.data.listviews)
        );
      })
      .catch((error) => {
        dispatch(getSalesforceListviewsFailure(error.response));
      });
  };
}

/*** POST /salesforce/config ***/
const postSalesforceConfigRequest = () => ({
  type: POST_SALESFORCE_CONFIG_REQUEST,
});

const postSalesforceConfigSuccess = () => ({
  type: POST_SALESFORCE_CONFIG_SUCCESS,
});

const postSalesforceConfigFailure = (error) => ({
  type: POST_SALESFORCE_CONFIG_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceConfig(data) {
  return async (dispatch) => {
    dispatch(postSalesforceConfigRequest());

    SalesforceApi.postSalesforceConfig(data, dispatch)
      .then(() => {
        dispatch(postSalesforceConfigSuccess());
      })
      .catch((error) => {
        dispatch(postSalesforceConfigFailure(error.response));
      });
  };
}

export function configAndSync(data) {
  return async (dispatch) => {
    dispatch(postSalesforceConfigRequest());

    SalesforceApi.postSalesforceConfig(data, dispatch)
      .then(() => {
        dispatch(postSalesforceConfigSuccess());
        dispatch(postSalesforceSync());
      })
      .catch((error) => {
        dispatch(postSalesforceConfigFailure(error.response));
      });
  };
}

/*** GET /salesforce/describe***/
const getSalesforceDescribeExeExportRequest = () => ({
  type: GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST,
});

const getSalesforceDescribeExeExportSuccess = ({ Contact, Account, Lead }) => ({
  type: GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS,
  payload: {
    contactFields: Contact,
    accountFields: Account,
    leadFields: Lead,
  },
});

const getSalesforceDescribeExeExportFailure = (error) => ({
  type: GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceDescribeExeExport() {
  return async (dispatch) => {
    dispatch(getSalesforceDescribeExeExportRequest());

    let promises = [];

    Object.values(SalesforceExeExportObjectType).forEach((object) => {
      promises.push(
        SalesforceApi.getSalesforceDescribe(object.value, dispatch)
      );
    });

    Promise.all(promises)
      .then((values) => {
        let res = {};
        values.forEach((v) => {
          let data = v.data.data;
          res[data.name] = data.fields;
        });

        dispatch(getSalesforceDescribeExeExportSuccess(res));
      })
      .catch((error) => {
        dispatch(getSalesforceDescribeExeExportFailure(error.response));
      });
  };
}

/*** GET /salesforce/describe***/
const getSalesforceDescribeTimelineStatusExportRequest = () => ({
  type: GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST,
});

const getSalesforceDescribeTimelineStatusExportSuccess = ({ Event }) => ({
  type: GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS,
  payload: {
    eventFields: Event,
  },
});

const getSalesforceDescribeTimelineStatusExportFailure = (error) => ({
  type: GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceDescribeTimelineStatusExport() {
  return async (dispatch) => {
    dispatch(getSalesforceDescribeTimelineStatusExportRequest());

    let promises = [];

    Object.values(SalesforceTimelineStatusExportObjectType).forEach((object) => {
      promises.push(
        SalesforceApi.getSalesforceDescribe(object.value, dispatch)
      );
    });

    Promise.all(promises)
      .then((values) => {
        let res = {};
        values.forEach((v) => {
          let data = v.data.data;
          res[data.name] = data.fields;
        });

        dispatch(getSalesforceDescribeTimelineStatusExportSuccess(res));
      })
      .catch((error) => {
        dispatch(getSalesforceDescribeTimelineStatusExportFailure(error.response));
      });
  };
}

/*** POST /salesforce_export_mappings/exe ***/
const postSalesforceExportMappingsExeRequest = () => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST,
});

const postSalesforceExportMappingsExeSuccess = () => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS,
  payload: {},
});

const postSalesforceExportMappingsExeFailure = (error) => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceExportMappingsExe(data) {
  return async (dispatch) => {
    dispatch(postSalesforceExportMappingsExeRequest());

    SalesforceApi.postSalesforceExportMappingsExe(data, dispatch)
      .then(() => {
        dispatch(postSalesforceExportMappingsExeSuccess());
      })
      .catch((error) => {
        dispatch(postSalesforceExportMappingsExeFailure(error.response));
      });
  };
}

/*** POST /salesforce_export_mappings/timeline_status ***/
const postSalesforceExportMappingsTimelineStatusRequest = () => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST,
});

const postSalesforceExportMappingsTimelineStatusSuccess = () => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS,
  payload: {},
});

const postSalesforceExportMappingsTimelineStatusFailure = (error) => ({
  type: POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE,
  payload: {
    error: error,
  },
});

export function postSalesforceExportMappingsTimelineStatus(data) {
  return async (dispatch) => {
    dispatch(postSalesforceExportMappingsTimelineStatusRequest());

    SalesforceApi.postSalesforceExportMappingsTimelineStatus(data, dispatch)
      .then(() => {
        dispatch(postSalesforceExportMappingsTimelineStatusSuccess());
      })
      .catch((error) => {
        dispatch(postSalesforceExportMappingsTimelineStatusFailure(error.response));
      });
  };
}

/*** GET /salesforce_export_mappings ***/
const getSalesforceExportMappingsRequest = () => ({
  type: GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST,
});

const getSalesforceExportMappingsSuccess = (mapping) => ({
  type: GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS,
  payload: {
    mapping: mapping,
  },
});

const getSalesforceExportMappingsFailure = (error) => ({
  type: GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceExportMappings(data) {
  return async (dispatch) => {
    dispatch(getSalesforceExportMappingsRequest());

    SalesforceApi.getSalesforceExportMappings(data, dispatch)
      .then((response) => {
        let mapping = {};
        response.data.data.forEach((item) => {
          mapping[item.sobject_name] = item.mapping;
        });
        dispatch(getSalesforceExportMappingsSuccess(mapping));
      })
      .catch((error) => {
        dispatch(getSalesforceExportMappingsFailure(error.response));
      });
  };
}

/*** GET /salesforce_import_histories ***/
const getSalesforceImportHistoriesRequest = () => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_REQUEST,
});

const getSalesforceImportHistoriesSuccess = (data, pageInfo) => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  },
});

const getSalesforceImportHistoriesFailure = (error) => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceImportHistories(data) {
  return async (dispatch) => {
    dispatch(getSalesforceImportHistoriesRequest());

    SalesforceApi.getSalesforceImportHistories(data, dispatch)
      .then((response) => {
        dispatch(
          getSalesforceImportHistoriesSuccess(
            response.data.data,
            response.data.meta
          )
        );
      })
      .catch((error) => {
        dispatch(getSalesforceImportHistoriesFailure(error.response));
      });
  };
}

/*** GET /salesforce_import_histories/{id} ***/
const getSalesforceImportHistoriesByIdRequest = () => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST,
});

const getSalesforceImportHistoriesByIdSuccess = (data) => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS,
  payload: {
    data: data,
  },
});

const getSalesforceImportHistoriesByIdFailure = (error) => ({
  type: GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceImportHistoriesById(id) {
  return async (dispatch) => {
    dispatch(getSalesforceImportHistoriesByIdRequest());

    SalesforceApi.getSalesforceImportHistoriesById(id, dispatch)
      .then((response) => {
        dispatch(getSalesforceImportHistoriesByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getSalesforceImportHistoriesByIdFailure(error.response));
      });
  };
}

/*** GET /salesforce_export_histories ***/
const getSalesforceExportHistoriesRequest = () => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_REQUEST,
});

const getSalesforceExportHistoriesSuccess = (data, pageInfo) => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  },
});

const getSalesforceExportHistoriesFailure = (error) => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceExportHistories(data) {
  return async (dispatch) => {
    dispatch(getSalesforceExportHistoriesRequest());

    SalesforceApi.getSalesforceExportHistories(data, dispatch)
      .then((response) => {
        dispatch(
          getSalesforceExportHistoriesSuccess(
            response.data.data,
            response.data.meta
          )
        );
      })
      .catch((error) => {
        dispatch(getSalesforceExportHistoriesFailure(error.response));
      });
  };
}

/*** GET /salesforce_export_histories/{id} ***/
const getSalesforceExportHistoriesByIdRequest = () => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST,
});

const getSalesforceExportHistoriesByIdSuccess = (data) => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS,
  payload: {
    data: data,
  },
});

const getSalesforceExportHistoriesByIdFailure = (error) => ({
  type: GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export function getSalesforceExportHistoriesById(id) {
  return async (dispatch) => {
    dispatch(getSalesforceExportHistoriesByIdRequest());

    SalesforceApi.getSalesforceExportHistoriesById(id, dispatch)
      .then((response) => {
        dispatch(getSalesforceExportHistoriesByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getSalesforceExportHistoriesByIdFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/Salesforce.js